import { Component, OnInit, Input,  Output, EventEmitter } from '@angular/core';
import { AdminService } from './admin.service';

import {Router } from '@angular/router';


declare var $: any;
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
    userName: String;
	@Input() showHeader: Boolean;
  @Output() emitPass: EventEmitter<any> = new EventEmitter<any>();
  constructor(private router : Router) { }

  ngOnInit(): void {
      this.userName = localStorage.getItem('name');
  }
  logout() {
    localStorage.clear();
  this.showHeader = false;
  this.emitPass.emit(this.showHeader);
    this.router.navigate(['/']);
}
}
